import { makeEnterpriseRoute } from '@neptune/shared/enterprise-context-business-logic';
import { AppRoute } from '@neptune/shared/routing-domain';

import { getInitiativesEnabled } from 'common/featureFlag';

const initiativeRoute: AppRoute = {
  name: 'project.initiative',
  path: '/initiatives/:initiativeId',
};

const boardRoute: AppRoute = {
  name: 'project.initiative.board',
  path: '/boards/:boardId',
};

const sideBySideRoute: AppRoute = {
  name: 'project.initiative.side-by-side',
  path: '/side-by-side',
};

export const initiativesRoutes = getInitiativesEnabled()
  ? [
      initiativeRoute,
      makeEnterpriseRoute(initiativeRoute),
      boardRoute,
      makeEnterpriseRoute(boardRoute),
      sideBySideRoute,
      makeEnterpriseRoute(sideBySideRoute),
    ]
  : [];
